<template>
<div class="inner_left">
  <div class="inner_contain_left left">
    <div class="order">
      <ul class="order_ul" ref="myul" @mouseenter="stop" @mouseleave="go">
        <li v-for="(list, index) of slideList" :key="index">
          <p>
            <span class="icon_wrap">
              <i class="iconfont icon-zq"></i>
            </span>
            {{ list.userName | hide }}订阅了{{ roomData.teacherName }}的
            <!--cjg-->
            <nuxt-link  v-if="list.type === 1"  target="_blank" rel="noopener" class="href" :to="`/article/detail/${list.relationId}`">{{ list.relationName }}</nuxt-link>
            <!--付费观点-->
            <span v-if="list.type === 4"  class="href">付费观点</span>
            <!--vip-->
            <nuxt-link v-if="list.type === 7" target="_blank" rel="noopener" class="href" :to="`/vip/detail/${roomData.teacherId}`">{{ list.relationName }}</nuxt-link>
          </p>
        </li>
      </ul>
    </div>
    <!--老师的可购买产品轮播    ele-ui框架-->
    <div class="goods_menu">
      <el-carousel trigger="click" height="120px" indicator-position="none" arrow="always" v-if="goodsData.length">
        <el-carousel-item v-for="(v, index) in goodsData" :key="index">
          <div class="wrap">
            <div class="item">
               <div class="title yf-text_14">
                <p class="ellipsis"><span class="title_type yf-text_12">{{v.type === 'vip' ? '特训班' : v.data.type === 1 ? 'CJG' : '付费文章' }}</span>{{ roomData.teacherName }}：<span>{{ v.data.title }}</span></p>
               </div>
               <!-- 文章 -->
               <div class="inner_content cjg clearfix" v-if="v.type === 'article'">
                 <div class="text left">
                   <p>订阅期限：<span v-if="v.data.createAt">{{ v.data.createAt.slice(0, 10) }}</span>至<span v-if="v.data.stopTime">{{ v.data.stopTime.slice(0, 10) }}</span></p>
                   <!-- <p>剩余名额：<span>{{ v.Count > -1 ? v.Count :'无限制'  }}</span></p> -->
                   <p>课程价格：<span class="yf-text_red">{{ v.data.promotionGcoins }}G币</span></p>
                 </div>
                 <nuxt-link class="button left" target="_blank" rel="noopener" :to="`/article/detail/${v.data.id}`">立即订阅</nuxt-link>
               </div>
               <!-- 特训班 -->
               <div class="inner_content vip clearfix" v-else-if="v.type === 'vip' && v.data.price && v.data.price.length > 0">
                 <div class="text left">
                   <p>订阅周期</p>
                   <p class="price yf-text_14">
                      <span v-for="(item, i) in processVipPrices(v.data.price)" :key="i" v-if="i < 2">
                      <span v-show="i === 1">、</span>{{ item.level }}交易日/<em class="yf-text_red">{{ item.gcoins }}</em>G币<span v-show="i === 1 && processVipPrices(v.data.price).length > 2">...</span></span>
                   </p>
                 </div>
                 <nuxt-link class="button left" target="_blank" rel="noopener" :to="`/vip/detail/${roomData.teacherId}`" >查看详情</nuxt-link>
               </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="noordercjg" v-else>暂无可订阅产品</div>
    </div>
  </div>
  <div class="inner_contain_right right">
    <!-- <div class="vote-wrap">
      <div class="clearfix">
        <p class="rank left">老师本月得票<span class="yellow">{{ totalVoteNum | convertVote }}</span>，排名<span :class="{ yellow: voteRank > 0 }">{{ voteRank > 0 ? voteRank : '未上榜' }}</span></p>
        <nuxt-link class="right" to="/activity" target="_blank">详情 &raquo;</nuxt-link>
      </div>
      <div class="vote">
        <div class="input_wrap">
          <input type="text" v-model="voteNum" placeholder="请输入支持老师的票数" /><span @click="handleVote">投票</span>
        </div>
      </div>
    </div> -->
    <p class="rank">老师本月得票<span class="red">{{ totalVoteNum > 0 ? totalVoteNum : 0 }}</span>，排名<span :class="{ red: voteRank > 0 }">{{ voteRank > 0 ? voteRank : '未上榜' }}</span> <span class="red">{{ voteRank > 0 ? ( voteRank > preVoteRank ? "" : "↑" ) : "" }}</span></p>
    <div class="vote">
      <div class="input_wrap">
        <input type="text" v-model="voteNum" placeholder="请输入支持老师的票数" /><span @click="handleVote">投票</span>
      </div>
    </div>
    <div class="help_nav">
      <el-popover
        ref="kf"
        placement="top-start"
        width="304"
        trigger="click">
        <a slot="reference">
          <div>
            <i class="iconfont icon-qq1"></i>
          </div>
          <p>客服服务</p>
        </a>
        <ul class="kf">
          <li>一一QQ号：1536972572</li>
          <li>财富QQ号：2950972868</li>
          <li>富富QQ号：2725731686</li>
        </ul>
      </el-popover>
      <!-- 登陆和未登陆显示的按钮是不同的 -->
      <nuxt-link target="_blank" rel="noopener" :to="authUser ? '/user/article' : `/article/list/${roomData.teacherId}`">
        <div>
          <i class="iconfont icon-jituanguanli"></i>
        </div>
        <p>{{ authUser ? '我的藏金阁' : '藏金阁' }}</p>
      </nuxt-link>
      <!-- over -->
      <a target="_blank" rel="noopener" href="/about?type=2">
        <div>
          <i class="iconfont icon-bangzhu"></i>
        </div>
        <p>帮助中心</p>
      </a>
      <nuxt-link target="_blank" rel="noopener" style="border-right: 0" :to="`/room/history-list/${roomData.teacherId}`">
        <div><i class="iconfont icon-rizhiguanli"></i></div>
        <p>直播历史</p>
      </nuxt-link>
    </div>
  </div>
</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Dialog from '@/utils/Dialog'

export default {
  name: 'vote',
  data () {
    return {
      //    每月策略处轮播
      slideList:[],
      currentIndex: 0,
      timer:'',

      // 投票
      voteNum: '',
      votePrice: 2,
      voteRank: 0,
      preVoteRank: 0
    }
  },
  mounted () {
    //加载最新5条购买记录
    this.loadOrder()
    // 加载投票信息
    this.loadVote()

    this.$nextTick(() => {
      var self = this
      var num = 0
      this.timer = setInterval(function(){
        num = parseInt(num)-1
        if ( num == -171){
          num = 19
        }
        num = num+'px'
        self.$refs.myul.style.top = num
      },90)
    })
  },
  destroyed () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    //  订阅记录相关方法
    go () {
      var self = this
      var num = self.$refs.myul.style.top
      this.timer = setInterval(function(){
        num = parseInt(num)-1
        if (num == -171){
          num = 19
        }
        num = num + 'px'
        self.$refs.myul.style.top = num
      }, 90)
    },
    stop () {
      clearInterval(this.timer)
      this.timer = null
    },
    // 加载订阅记录
    loadOrder () {
      // this.$axios._get('/Teacher/GoodsOrder', {id: this.roomData.teacherId}).then(res => {
      //   this.slideList = res
      // })
    },
    // 投票数据
    loadVote () {
      //正常调阅接口
      this.$axios._get('/Teacher/Rank', { id: this.roomData.teacherId, type: 1 }).then(res => {
        if (res) {
          this.$store.commit('teacher/initVoteNum')
          this.$store.commit('teacher/setVoteNum', res.num)
          this.voteRank = res.rank
          this.preVoteRank = res.preRank
        }
      }).catch(err => {
        console.log(1, err)
      })  
      
      //年终活动调阅接口
      // let  param = {teacherId: this.roomData.teacherId }
      
      // this.$axios._get('/YearActivities/VoteInfo', param).then(res => {
      //   if (res) {
      //     this.$store.commit('teacher/initVoteNum')
      //     this.$store.commit('teacher/setVoteNum', res.num || res[0].vote)
      //     this.voteRank = res.rank || res[0].rank
      //     if (!this.yihui) this.preVoteRank = res.preRank
      //   }
      // }).catch(err => {
      //   console.log(1, err)
      // })

    },
    // 投票
    handleVote () {
      if (!this.$isLogin()) {
        Dialog.login()
      } else {
        // 投票数量
        if (this.voteNum < 1) {
          this.$notify({
            type: 'warning',
            title: '警告',
            message: '请输入正确的投票数量'
          })
          return false
        }
        if (this.voteNum > 100000) {
          this.$notify({
            type: 'warning',
            title: '警告',
            message: '投票数不能大于五位数'
          })
          return false
        }

        // 投票确认
        Dialog.confirm('消费确认', `本次投票共计消费${this.voteNum * this.votePrice}个G币，请确认支付`).then(_ => {
          // 投票请求
          this.$axios._post('/Room/Vote', {
            host_id: this.roomData.lastTopicId,
            num: this.voteNum,
            type: 1
          }).then(res => {
            if (!this.$store.state.room.isWebsocket) {
              this.$store.commit('room/addMessage', res)
              this.$store.commit('teacher/setVoteNum', this.voteNum)
            }
            this.$store.commit('user/setGcoins', this.authUser.gcoins - (this.voteNum * this.votePrice))
            this.voteNum = ''
            this.$notify({
              title: '成功',
              message: '投票成功！',
              type: 'success'
            })
          })
        })
      }
    },
    // 处理特训班的价格, 过滤掉价格为0的
    processVipPrices (prices) {
      return prices.filter(item => item.gcoins > 0)
    }
  },
  filters: {
    hide (name) {
      if (name) {
        let len = name.length
        if (len === 1) {
          return name + '*'
        } else if (len === 2) {
          return name.slice(0, 1) + '*'
        } else {
          return name.slice(0, 1) + '*'.repeat(len - 2) + name.slice(len - 1)
        }
      } else {
        return ''
      }
    }
    },
  computed: {
    ...mapState({
      totalVoteNum: state => state.teacher.totalVoteNum,
      roomData: state => state.room.data,
      authUser: state => state.user.data
    }),
    ...mapGetters({
      goodsData: 'teacher/goodsData'
    })
  },
  watch:{
    voteNum (n) {
      this.voteNum = n > 0 ? parseInt(n) : ''
    }
  }
}
</script>

<style lang="less" scoped>
.inner_left {
  width: 760px; height: 160px;
  .red { color: #e43a3d; }
  .inner_contain_left { width: 455px; height: 160px; background: #FFFFFF; }
  .inner_contain_right { border-left: 1px solid #e3e3e3; width: 305px; height: 160px; background: #FFFFFF;
    .rank {
      height: 40px; line-height: 40px; text-align: center; font-size: 14px; border-top: 1px solid #E3E3E3;
    }
    .vote { height: 47px; padding-top: 2px;
      .input_wrap { margin: 0 auto; width: 273px; height: 30px; overflow: hidden;
        input { float: left; width: 213px; padding-left: 10px; height: 30px; border: 1px solid #fac0ce; outline: none; border-right: none;}
        span { float: left; text-align: center; line-height: 30px; width: 60px; height: 30px; background: #e43a3d; color: #fff7ee; cursor: pointer; }
      }
    }
    .help_nav {
      overflow: hidden;
      a { width: 76px; height: 74px; float: left; border-top: 1px solid #e2e2e2; color: #676767;  border-right: 1px solid #E2E2E2; border-bottom: 1px solid #E2E2E2; text-align: center; cursor: pointer;
        &:hover {
          i { font-size: 35px; color: #e7735a; }
          p { color:#e7735a ; }
        }
        > div {
          height:50px; line-height: 50px;
          i { font-size: 30px; width: 30px; height: 33px; transition: all 0.3s;}
        }
      }
    }
  }

}
// .inner_left {
//   width: 760px; height: 160px;
//   .red { color: #e43a3d; }
//   .yellow {
//     color: #ffff00;
//   }
//   .inner_contain_left { width: 455px; height: 160px; background: #FFFFFF; }
//   .inner_contain_right {
//     border-left: 1px solid #e3e3e3; width: 305px; height: 160px; background: #FFFFFF;
//     .vote-wrap {
//       background-image: url(~assets/activity/room-vote.jpg); width: 304px; height: 125px;
//       > div:first-child {
//         padding: 50px 16px 0; color: #ffffff;
//         a {
//           color: #ffffff; font-size: 14px;
//         }
//       }
//       .rank {
//         text-align: center; font-size: 14px;
//       }
//     }
//     .vote { height: 47px; margin-top: 10px;
//       .input_wrap { margin: 0 auto; width: 273px; height: 30px;
//         input {
//           float: left; width: 193px; padding-left: 10px; height: 30px; border: none; outline: none; border-right: none;
//         }
//         span {
//           float: left; text-align: center; line-height: 30px; width: 80px; height: 30px; background: #e43a3d; color: #fff7ee; cursor: pointer; background-image: url(~assets/activity/room-vote-btn.jpg);
//         }
//       }
//     }
//     > div:not(.vote-wrap) {
//       .rank {
//         height: 40px; line-height: 40px; text-align: center; font-size: 14px; border-top: 1px solid #E3E3E3;
//       }
//       .vote {
//         padding-top: 2px; margin-top: 0;
//         .input_wrap {
//           input {
//             width: 213px; border: 1px solid #fac0ce;
//           }
//           span {
//             width: 58px; background-image: url();
//           }
//         }
//       }
//     }
//     .help_nav {
//       overflow: hidden;
//       a { width: 25%; float: left; border-top: 1px solid #e2e2e2; color: #676767;  border-right: 1px solid #E2E2E2; border-bottom: 1px solid #E2E2E2; text-align: center; cursor: pointer; line-height: 35px;
//         &:hover {
//           i { font-size: 35px; color: #e7735a; }
//           p { color: #e7735a; }
//         }
//         > div {
//           height: 50px; line-height: 50px;
//           i { font-size: 30px; width: 30px; height: 33px; transition: all 0.3s; }
//         }
//       }
//       &.yihui {
//         a {
//           height: 74px; line-height: 1;
//         }
//       }
//     }
//   }

// }
/*购买特训班轮播*/
.goods_menu {
  .el-carousel__arrow { width: 14px !important; height: 36px !important; border-radius: 0 !important;}

  .noordercjg { height: 120px; line-height: 120px;
    text-align: center; font-size: 16px; color: #999999;

  }
  .wrap { height: 100%; background: #FFFFFF; padding: 0 40px; padding-left: 41px;
    .item { height: 100%;
      > .title { height: 40px; margin-top: 10px;
        > p { height: 40px; line-height: 40px; color: #676767; font-weight: 600; width: 380px;
          .title_type { padding: 3px 12px; background: #ffac2c; color: #FFFFFA; border-radius: 10px; margin-right: 5px;}
        }
      }
      > .inner_content { height: 80px;
        > .text { color: #999; width: 260px;
          p { line-height: 21px; }
          
        }
        .button { text-align: center; width: 99px; height: 36px; line-height: 36px; background: #e43a3d; color: #fff; border-radius: 20px; }
      }
      .cjg {
        .button { top: 24px; }
      }
      .vip {
        .price { color: #676767; width: 260px; }
        .button { top: 8px; }
      }
    }
  }
}

/*每月策略轮播*/
.order { position: relative; height: 40px; background: #f7f7f7; border-bottom: 1px solid #E3E3E3; border-top: 1px solid #E3E3E3; line-height: 40px; overflow: hidden;
  .list-leave-active {  transform: translateY(100%)}
  /*.list-leave-to { transform: translateX(-100%)}*/
  .list-enter-active {
       /*transition: all 1s ease;*/
       transform: translateY(0)
  }

  .order_ul { width: 100%; position: absolute; top: 0px;
    li { width: 100%; height: 38px;
      p { color: #6c6c6c; padding-left: 4px;
        > .icon_wrap { margin-right: 4px; vertical-align: middle;
          > i { font-size: 18px; color: #E2383B;}
        }
        > .text { margin-left: 5px;
        }
        > .productype {margin-right: 10px;}
        > span,a { color: #679ed7;}
      }
    }
  }
}
</style>
